/* eslint-disable no-param-reassign */
import produce from 'immer';
import { PROVIDERS_COLLECTED } from 'src/actions/providerActions';

const initialState = {
  providers: []
};

const providerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROVIDERS_COLLECTED: {
      const { providers } = action.payload;

      return produce(state, (draft) => {
        draft.providers = providers;
      });
    }

    default: {
      return state;
    }
  }
};

export default providerReducer;
